import { GTM_DATA_ID_ATTR } from '../constants';

const buildLinkExtraProps = ({ className, name, title, as, gtmId }) => {
  const linkExtraProps = {};
  if (as) linkExtraProps.as = as;
  if (className) linkExtraProps.className = className;
  if (name) linkExtraProps.name = name;
  if (gtmId) linkExtraProps[GTM_DATA_ID_ATTR] = gtmId;
  return linkExtraProps;
};

export default buildLinkExtraProps;
